/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetCreateUpdateRequest {
    getFixupPrototypeFunction() { return BudgetCreateUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<BudgetCreateUpdateRequest>): BudgetCreateUpdateRequest {
        let obj = Object.assign(new BudgetCreateUpdateRequest(), model);
        BudgetCreateUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetCreateUpdateRequest>): BudgetCreateUpdateRequest {
        if (!model) return null;
        return BudgetCreateUpdateRequest.newInstance(<BudgetCreateUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetCreateUpdateRequest) {
        if (!obj) return;

        models.BudgetCreateUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetCreateUpdateRequest): boolean {
        Object.setPrototypeOf(obj, BudgetCreateUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_details) {
            models.BudgetDetailsModel.fixupPrototype(this.budget_details);
        }
        if (this.metadata) {
            models.BudgetMetaModel.fixupPrototype(this.metadata);
        }
        if (this.budget_amount) {
            models.BudgetAmountModel.fixupPrototype(this.budget_amount);
        }
    }

    /**
     * Provide a name for your budget
     */
    budget_name: string;

    /**
     * Id of Budget to create budget data
     */
    budget_id: string;

    /**
     * The status of the budget corresponds to its budget ID and can be in one of the following states:  pending: This is the state before the budget has been synchronized. in_Progress: This is the state when the budget is currently being synchronized. completed: This is the state when the budget has successfully completed its synchronization.
     */
    status: models.BudgetStatus;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_id: string;

    /**
     * budget event type.
     */
    budget_event_type: models.BudgetEventType;

    /**
     * Specify the budget frequency. Example: 'budget frequency':'Daily' Allowed values - Daily,Monthly,Quarterly,Annually
     */
    budget_frequency: string;

    /**
     * Budget type will Be COST for AWS and Cost for Azure
     */
    budget_type: string;

    /**
     * Get details of a specific budget id within a given budget id
     */
    budget_details: models.BudgetDetailsModel;

    /**
     * Metadata like file name, file format
     */
    metadata: models.BudgetMetaModel;

    /**
     * example: Currency of the cost. Example 'currency’: ‘USD’
     */
    budget_amount: models.BudgetAmountModel;

}
